import OpenAI from 'openai';

/**
 * Initializes the OpenAI client with the API key from environment variables.
 * @returns {OpenAI} Configured OpenAI client instance.
 */
const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true, // Required for client-side usage in React
});

/**
 * Recommended OpenAI models for different use cases:
 * - gpt-4o: Latest and most capable model (recommended for complex tasks)
 * - gpt-4o-mini: Faster and more cost-effective (recommended for simple tasks)
 * - gpt-4-turbo: Previous generation flagship model
 * - gpt-3.5-turbo: Fast and economical for simple tasks
 */
export const OPENAI_MODELS = {
  FLAGSHIP: 'gpt-4o',
  MINI: 'gpt-4o-mini',
  TURBO: 'gpt-4-turbo',
  LEGACY: 'gpt-3.5-turbo'
};

export default openai;